// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"731":"dee9fffc69783bea","2888":"a4785e35f413d1fc"}[chunkId] + ".css";
};